document.addEventListener("msa/region-locked-products/region-update", e => {
	if (e instanceof CustomEvent && e.detail['onLoad']) {
		localStorage.removeItem("msa/request-a-quote/products");
		document.dispatchEvent(new Event("msa/region-locked-products/quote-update"));
	}
});
